import { render } from "./AccountLayout.vue?vue&type=template&id=74358d13&scoped=true&ts=true"
import script from "./AccountLayout.vue?vue&type=script&lang=ts"
export * from "./AccountLayout.vue?vue&type=script&lang=ts"

import "./AccountLayout.vue?vue&type=style&index=0&id=74358d13&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74358d13"]])

export default __exports__